/**
 * Detect whether the current device is mobile/tablet.
 * Uses multiple signals because modern browsers and hybrid devices
 * can report pointer capabilities inconsistently.
 */
export function isMobile(): boolean {
  if (typeof window === "undefined") return false;

  const nav = window.navigator;
  const uaData = (nav as Navigator & { userAgentData?: { mobile?: boolean } }).userAgentData;
  if (typeof uaData?.mobile === "boolean") return uaData.mobile;

  const userAgent = nav.userAgent || "";
  const mobileUserAgent =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(
      userAgent
    );

  if (mobileUserAgent) return true;

  const hasCoarsePointer = window.matchMedia("(pointer: coarse)").matches;
  const hasTouch = nav.maxTouchPoints > 0;
  const mobileViewport = window.matchMedia("(max-width: 1024px)").matches;

  // Final fallback: treat touch-first small/medium viewports as mobile-like.
  // This intentionally biases toward true for phones and tablets.
  return hasTouch && (hasCoarsePointer || mobileViewport);
}
